"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = processGAClientId;

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

// We assume that if window.ga is already loaded, then the tracker must already exist.
// If window.ga is already defined, we assume that it was defined by the official GA script.
// It's possible that an app that imports Heliotrope might pre-define window.ga, causing our
// immediate adding to the queue to fail as it will be queued before the tracker is created.
function processGAClientId() {
  return _processGAClientId.apply(this, arguments);
}

function _processGAClientId() {
  _processGAClientId = _asyncToGenerator(function* () {
    return new Promise(res => {
      setTimeout(res, 3000);

      var getId = tracker => {
        var clientId = tracker && tracker.get && tracker.get('clientId');
        res(clientId);
      };

      if (window.ga) {
        window.ga(getId);
      }

      window.ga = window.ga || function () {
        (window.ga.q = window.ga.q || []).push(arguments); // In order to get the clientId, a tracker must exist. This ensures that getId gets called
        // only after a tracker has been created.  

        if (arguments[0] === 'create') {
          window.ga(getId);
        }
      };
    });
  });
  return _processGAClientId.apply(this, arguments);
}
//# sourceMappingURL=processGAClientId.js.map